import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, CheckCircle, Edit } from 'lucide-react';
import { Button } from '../components/ui/Button';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/Card';
import { Checkbox } from '../components/ui/Checkbox';
export function RegisterStep4() {
  const navigate = useNavigate();
  const [registrationData, setRegistrationData] = useState<any>(null);
  const [agreements, setAgreements] = useState({
    terms: false,
    privacy: false,
    newsletter: false
  });
  const [submitting, setSubmitting] = useState(false);
  useEffect(() => {
    const savedData = localStorage.getItem('registrationData');
    if (!savedData) {
      navigate('/register/step1');
      return;
    }
    setRegistrationData(JSON.parse(savedData));
  }, [navigate]);
  const handleSubmit = async () => {
    // Validation
    if (!agreements.terms || !agreements.privacy) {
      alert('Anda harus menyetujui Syarat & Ketentuan dan Kebijakan Privasi');
      return;
    }
    setSubmitting(true);
    // Simulate API call
    setTimeout(() => {
      setSubmitting(false);
      localStorage.removeItem('registrationData');
      alert('Permohonan keanggotaan berhasil dikirim! Anda akan dihubungi dalam 3-5 hari kerja.');
      navigate('/login');
    }, 2000);
  };
  if (!registrationData) return null;
  const {
    membershipType,
    personalData,
    documents
  } = registrationData;
  const membershipTypeLabels: Record<string, string> = {
    individu: 'Anggota Individu',
    organisasi: 'Anggota Organisasi',
    badan_usaha: 'Anggota Badan Usaha',
    mitra: 'Mitra Asosiasi'
  };
  return <div className="min-h-screen bg-gradient-to-br from-atios-primary to-blue-700" data-id="element-4989">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-4990">
        {/* Header */}
        <div className="text-center mb-8" data-id="element-4991">
          <h1 className="text-4xl font-bold text-white mb-3" data-id="element-4992">
            Tinjau Data Anda
          </h1>
        </div>

        {/* Progress Bar */}
        <div className="mb-12" data-id="element-4993">
          <div className="flex items-center justify-between mb-2" data-id="element-4994">
            <span className="text-sm font-medium text-white" data-id="element-4995">
              Langkah 4 dari 5
            </span>
            <span className="text-sm text-white/80" data-id="element-4996">80%</span>
          </div>
          <div className="w-full bg-white/20 rounded-full h-2" data-id="element-4997">
            <div className="bg-cyan-400 h-2 rounded-full transition-all" style={{
            width: '80%'
          }} data-id="element-4998" />
          </div>
        </div>

        {/* Review Sections */}
        <div className="space-y-6" data-id="element-4999">
          {/* Membership Type */}
          <Card data-id="element-5000">
            <CardHeader className="flex flex-row items-center justify-between" data-id="element-5001">
              <CardTitle data-id="element-5002">Jenis Keanggotaan</CardTitle>
              <Button variant="link" size="sm" onClick={() => navigate('/register/step1')} className="text-cyan-600" data-id="element-5003">
                <Edit className="w-4 h-4 mr-1" data-id="element-5004" />
                Ubah
              </Button>
            </CardHeader>
            <CardContent data-id="element-5005">
              <p className="text-lg font-medium text-neutral-900" data-id="element-5006">
                {membershipTypeLabels[membershipType]}
              </p>
            </CardContent>
          </Card>

          {/* Personal Data */}
          <Card data-id="element-5007">
            <CardHeader className="flex flex-row items-center justify-between" data-id="element-5008">
              <CardTitle data-id="element-5009">Data Pribadi</CardTitle>
              <Button variant="link" size="sm" onClick={() => navigate('/register/step2')} className="text-cyan-600" data-id="element-5010">
                <Edit className="w-4 h-4 mr-1" data-id="element-5011" />
                Ubah
              </Button>
            </CardHeader>
            <CardContent data-id="element-5012">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-5013">
                <div data-id="element-5014">
                  <p className="text-sm text-neutral-600" data-id="element-5015">Nama Lengkap</p>
                  <p className="font-medium text-neutral-900" data-id="element-5016">
                    {personalData?.fullName}
                  </p>
                </div>
                <div data-id="element-5017">
                  <p className="text-sm text-neutral-600" data-id="element-5018">Email</p>
                  <p className="font-medium text-neutral-900" data-id="element-5019">
                    {personalData?.email}
                  </p>
                </div>
                <div data-id="element-5020">
                  <p className="text-sm text-neutral-600" data-id="element-5021">Nomor Telepon</p>
                  <p className="font-medium text-neutral-900" data-id="element-5022">
                    {personalData?.phone}
                  </p>
                </div>
                <div data-id="element-5023">
                  <p className="text-sm text-neutral-600" data-id="element-5024">Tanggal Lahir</p>
                  <p className="font-medium text-neutral-900" data-id="element-5025">
                    {personalData?.dateOfBirth}
                  </p>
                </div>
                <div className="md:col-span-2" data-id="element-5026">
                  <p className="text-sm text-neutral-600" data-id="element-5027">Alamat</p>
                  <p className="font-medium text-neutral-900" data-id="element-5028">
                    {personalData?.address}
                  </p>
                </div>
                <div data-id="element-5029">
                  <p className="text-sm text-neutral-600" data-id="element-5030">Kota</p>
                  <p className="font-medium text-neutral-900" data-id="element-5031">
                    {personalData?.city}
                  </p>
                </div>
                <div data-id="element-5032">
                  <p className="text-sm text-neutral-600" data-id="element-5033">Provinsi</p>
                  <p className="font-medium text-neutral-900" data-id="element-5034">
                    {personalData?.province}
                  </p>
                </div>
                <div data-id="element-5035">
                  <p className="text-sm text-neutral-600" data-id="element-5036">Kode Pos</p>
                  <p className="font-medium text-neutral-900" data-id="element-5037">
                    {personalData?.postalCode}
                  </p>
                </div>
                <div data-id="element-5038">
                  <p className="text-sm text-neutral-600" data-id="element-5039">Keahlian</p>
                  <div className="flex flex-wrap gap-2 mt-1" data-id="element-5040">
                    {personalData?.skills?.map((skill: string, i: number) => <span key={i} className="px-2 py-1 bg-cyan-100 text-cyan-700 text-xs rounded" data-id="element-5041">
                        {skill}
                      </span>)}
                  </div>
                </div>
                {personalData?.bio && <div className="md:col-span-2" data-id="element-5042">
                    <p className="text-sm text-neutral-600" data-id="element-5043">Biografi</p>
                    <p className="font-medium text-neutral-900" data-id="element-5044">
                      {personalData.bio}
                    </p>
                  </div>}
              </div>
            </CardContent>
          </Card>

          {/* Documents */}
          <Card data-id="element-5045">
            <CardHeader className="flex flex-row items-center justify-between" data-id="element-5046">
              <CardTitle data-id="element-5047">Dokumen Pendukung</CardTitle>
              <Button variant="link" size="sm" onClick={() => navigate('/register/step3')} className="text-cyan-600" data-id="element-5048">
                <Edit className="w-4 h-4 mr-1" data-id="element-5049" />
                Ubah
              </Button>
            </CardHeader>
            <CardContent data-id="element-5050">
              <div className="space-y-3" data-id="element-5051">
                {documents?.profilePhoto && <div className="flex items-center gap-2" data-id="element-5052">
                    <CheckCircle className="w-5 h-5 text-success" data-id="element-5053" />
                    <span className="text-neutral-900" data-id="element-5054">
                      Foto Profil: {documents.profilePhoto}
                    </span>
                  </div>}
                {documents?.identityDocument && <div className="flex items-center gap-2" data-id="element-5055">
                    <CheckCircle className="w-5 h-5 text-success" data-id="element-5056" />
                    <span className="text-neutral-900" data-id="element-5057">
                      Kartu Identitas: {documents.identityDocument}
                    </span>
                  </div>}
                {documents?.educationCertificate && <div className="flex items-center gap-2" data-id="element-5058">
                    <CheckCircle className="w-5 h-5 text-success" data-id="element-5059" />
                    <span className="text-neutral-900" data-id="element-5060">
                      Sertifikat Pendidikan: {documents.educationCertificate}
                    </span>
                  </div>}
                {documents?.workExperience && <div className="flex items-center gap-2" data-id="element-5061">
                    <CheckCircle className="w-5 h-5 text-success" data-id="element-5062" />
                    <span className="text-neutral-900" data-id="element-5063">
                      Surat Keterangan Kerja: {documents.workExperience}
                    </span>
                  </div>}
              </div>
            </CardContent>
          </Card>

          {/* Terms & Conditions */}
          <Card data-id="element-5064">
            <CardHeader data-id="element-5065">
              <CardTitle data-id="element-5066">Syarat & Ketentuan</CardTitle>
            </CardHeader>
            <CardContent data-id="element-5067">
              <div className="space-y-4" data-id="element-5068">
                <label className="flex items-start gap-3 cursor-pointer" data-id="element-5069">
                  <Checkbox checked={agreements.terms} onCheckedChange={checked => setAgreements(prev => ({
                  ...prev,
                  terms: !!checked
                }))} data-id="element-5070" />
                  <span className="text-sm text-neutral-700" data-id="element-5071">
                    Saya setuju dengan{' '}
                    <a href="#" className="text-cyan-600 hover:underline" data-id="element-5072">
                      Syarat & Ketentuan
                    </a>{' '}
                    <span className="text-error" data-id="element-5073">*</span>
                  </span>
                </label>
                <label className="flex items-start gap-3 cursor-pointer" data-id="element-5074">
                  <Checkbox checked={agreements.privacy} onCheckedChange={checked => setAgreements(prev => ({
                  ...prev,
                  privacy: !!checked
                }))} data-id="element-5075" />
                  <span className="text-sm text-neutral-700" data-id="element-5076">
                    Saya setuju dengan{' '}
                    <a href="#" className="text-cyan-600 hover:underline" data-id="element-5077">
                      Kebijakan Privasi
                    </a>{' '}
                    <span className="text-error" data-id="element-5078">*</span>
                  </span>
                </label>
                <label className="flex items-start gap-3 cursor-pointer" data-id="element-5079">
                  <Checkbox checked={agreements.newsletter} onCheckedChange={checked => setAgreements(prev => ({
                  ...prev,
                  newsletter: !!checked
                }))} data-id="element-5080" />
                  <span className="text-sm text-neutral-700" data-id="element-5081">
                    Saya ingin menerima newsletter dan update dari ATIOS
                  </span>
                </label>
              </div>
            </CardContent>
          </Card>
        </div>

        {/* Action Buttons */}
        <div className="flex gap-4 mt-8" data-id="element-5082">
          <Button type="button" variant="secondary" onClick={() => navigate('/register/step3')} className="flex-1" size="lg" data-id="element-5083">
            <ArrowLeft className="w-5 h-5 mr-2" data-id="element-5084" />
            Kembali
          </Button>
          <Button onClick={handleSubmit} disabled={submitting || !agreements.terms || !agreements.privacy} className="flex-1 bg-cyan-500 hover:bg-cyan-600" size="lg" data-id="element-5085">
            {submitting ? 'Mengirim...' : 'Kirim Permohonan'}
            <CheckCircle className="w-5 h-5 ml-2" data-id="element-5086" />
          </Button>
        </div>
      </div>
    </div>;
}